import { render, staticRenderFns } from "./InventoryInformation.vue?vue&type=template&id=a497df24&lang=pug&"
import script from "./InventoryInformation.vue?vue&type=script&lang=js&"
export * from "./InventoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./InventoryInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InventoryInformation.vue"
export default component.exports